import { MedrecordMoment, MomentLocaleConfigs } from './medrecord-moment.config';
import { TranslateService } from '@ngx-translate/core';

export function createMedrecordDateTimeFactory(translateService: TranslateService): () => void {
  return () => {
    translateService.onLangChange.subscribe(({ lang }) => {
      MedrecordMoment.updateLocale(lang, MomentLocaleConfigs[lang]);
    });
  };
}